module.exports = __webpack_public_path__ + "static/img/cover2.3dab881b.jpg";